import type { HotelAutocompleteOption } from '../../../hotel/HotelSearchForm';
import type { HotelRoom } from '../types/HotelRoom';

export const buildHotelTrackingItem = ({
    destinationContext,
    rooms,
    startDate,
    endDate,
}: {
    destinationContext?: HotelAutocompleteOption;
    rooms: HotelRoom[];
    startDate?: Date;
    endDate?: Date;
}) => {
    const numberOfAdults = rooms.reduce((sum, room) => sum + room.adults, 0);
    const numberOfChildren = rooms.reduce((sum, room) => sum + room.children.length, 0);

    return {
        id: 'finntravel',
        type: 'Travel',
        destination: destinationContext?.hierarchy?.[0],
        arrivalCity: destinationContext?.hierarchy?.[1],
        carriers: destinationContext?.type === 'hotel' ? [destinationContext.key] : undefined,
        travelType: 'hotel',
        departureDate: startDate?.toISOString(),
        returnDate: endDate?.toISOString(),
        numberOfAdults,
        numberOfChildren,
        numberOfRooms: rooms.length,
    };
};
